import { stockAvailabilitySlice } from "./stockAvailabilitySlice";
import * as actions from "./stockAvailabilityActions";
import * as selectors from './stockAvailabilitySelectors';

export { actions };
export { selectors };

export default stockAvailabilitySlice.reducer;